import Dashboard from "./components/dashboard/Dashboard";
import EmailTemplates from "./components/emailTemplates/EmailTemplates";
import TasklistTemplates from "./components/tasklist/TasklistTemplates";
import Portfolio from "./components/portfolio/Portfolio";
import GrantDetails from "./components/grantDetails/GrantDetails"; 
import Configuration from "./components/shared/Configuration";
import Logout from "./components/shared/Logout";
import Error from "./components/shared/Error";
import OIDCLogin from "./components/shared/OIDCLogin";
import SPSync from "./components/spsync/SPSync";
import SPSyncDetail from "./components/spsync/SPSyncDetail";
import UserManagement from "./components/userManagement/UserManagement";
import TemplateSync from "./components/templateSync/TemplateSync";
import AuditLog from "./components/auditLog/AuditLog";

const AppRoutes = [
    /*{
        index: true,
        element: <Logout />
    },*/
    {
        path: '/login',
        element: <Logout />
    },
    {
        path: '/login/oidc-callback',
        element: <OIDCLogin />
    },
    {
        path: '/dashboard',
        element: <Dashboard />
    },
    {
        path: '/email-templates',
        element: <EmailTemplates />
    },
    {
        path: '/tasklist-templates',
        element: <TasklistTemplates />
    },
    {
        path: '/tasklist-templates/modules/:moduleId',
        element: <TasklistTemplates />
    },
    {
        path: '/configuration',
        element: <Configuration />
    },
    {
        index: true,
        path: '/',
        element: <Portfolio />
    },
    {
        path: '/portfolio',
        element: <Portfolio />
    },
    {
        path: '/grantdetails/:id',
        element: <GrantDetails />
    },
    {
        path: '/logout',
        element: <Logout />
    },
    {
        path: '/oidcnotfound',
        element: <Error />
    },
    {
        path: '/oidcerror',
        element: <Error />
    },
    {
        path: '/error',
        element: <Error />
    },
    {
        path: '/user-management',
        element: <UserManagement />
    },
    {
        path: '/spSync',
        element: <SPSync />
    },
    {
        path: '/spSync/:id',
        element: <SPSyncDetail />
    },
    {
        path: '/template-sync',
        element: <TemplateSync />
    },
    {
        path: '/audit-log',
        element: <AuditLog />
    }
];

export default AppRoutes;
